import { render, staticRenderFns } from "./AppRekeningnummer.vue?vue&type=template&id=7ed6b537&scoped=true&"
import script from "./AppRekeningnummer.ts?vue&type=script&lang=ts&"
export * from "./AppRekeningnummer.ts?vue&type=script&lang=ts&"
import style0 from "./AppRekeningnummer.scss?vue&type=style&index=0&id=7ed6b537&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6b537",
  null
  
)

export default component.exports